import React, { memo, useLayoutEffect, useMemo } from 'react';
import { StyledChatMessagesList } from './ChatMessages.style';
import { IChatUserDto, IMessageDto } from '@/Models/Chat';
import MessageItem from './MessageItem';
import ChatMessagesSkeleton from './ChatMessagesSkeleton';


type Props = {
  chatData: IChatUserDto;
  messages: IMessageDto[];
  loading: boolean;
  scrollToBottom: () => void;
  newChat?: boolean;
}

const ChatMessages = ({ messages, loading, chatData, scrollToBottom, newChat }: Props) => {
  const normMessages = messages || [];

  useLayoutEffect(() => {
    scrollToBottom();
  })
  
  if((!chatData || loading) && !newChat) {
    return <ChatMessagesSkeleton />;
  }
  
  return (
    <StyledChatMessagesList className='chat-messages'>
      {
        normMessages.map((message) => <MessageItem chatData={chatData} key={message.id} message={message} />)
      }
    </StyledChatMessagesList>
  )
}

export default memo(ChatMessages);
